<template>
  <div class="login-card">
    <asset-v3 class="exclamationIcon" :dir="dir" :name="icon"/>
    <h1>
      Ops! Houve um erro ao carregar o conteúdo da página
    </h1>
    <p class="lead">
      Por favor, tente acessar novamente mais tarde.
    </p>
  </div>
</template>

<script>

import AssetV3 from '../common/AssetV3.vue';

export default ({
  name: 'ErrorCard',
  components: {
    AssetV3,
  },
  data() {
    return {
      dir: 'icons',
      icon: 'outline-exclamation-circle@2x.png',
    };
  },
});

</script>

<style lang="scss" scoped>
  h1 {
    line-height: 2.5rem;
    font-size: 2rem;
    margin-bottom: .75rem;
  }

  .login-card {
    background-color: white;
    width: 100%;
    max-width: 420px;
    border-radius: 1.5rem;
    padding: 24px;
    box-shadow: var(--shadow-elevation-high);

    @media (min-width: $md) {
      margin-top: 56px; //altura do footer
      padding: 36px;
    }
  }

  .lead {
    color: var(--color-gray-500);
  }

  .icon-background {
    display: flex;
    justify-content: center;
    align-items: center;
    width:48px;
    height: 48px;
    border-radius: 100%;
  }

  .exclamationIcon{
    background-color: var(--blue-200);
    border-radius: 50%;
    height: 24px;
    width: 24px;
    padding: 12px;
  }
</style>
